import template from './kereso.pug';
import keresoServiceModule from '../kereso-service';
import duScroll from 'angular-scroll';
const MODULE_NAME = 'kereso';
class KeresoController {
	constructor(keresoService, $location, $scope, $document) {
		'ngInject';
		this._keresoService = keresoService;
		this._$location = $location;
		this._$scope = $scope;
		this._$document = $document;
	}
	$onInit() {
		this.currentPage = 1;
		this.pageFilter = {
			size: 10,
			page: 0
		};

		this._$scope.$on('$locationChangeSuccess', ()=>{
			if (this._$location.search().term) {
				this.term = this._$location.search().term;
				this.filter = {
					q : this._$location.search().term
				};
				this.lista();
			}
		});
	}
	lapozas() {
		this.pageFilter.page = this.currentPage - 1;
		this.lista();
		var topAnchor = angular.element(document.getElementById('topanchor'));
		this._$document.scrollToElement(topAnchor);
	}
	lista(filter) {
		filter = angular.extend((filter || this.filter), this.pageFilter);
		this._keresoService.lista(filter, this.hirReszletesOldal).then((response) => {
			this.eredmenyek = response.hits;
			this.kiemeltEredmenyek = response.elevatedHits;
			this.numFound = response.totalNumberOfHits;
			this.filter = filter;
		}, () => {
			this.technikaiHiba = true;
		});
	}
}

export default angular.module(MODULE_NAME, [keresoServiceModule, duScroll])
	.component('kereso', {
		controller: KeresoController,
		template: template(),
		bindings : {
			hirReszletesOldal : '@'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/kereso/kereso/kereso.js